import { render, staticRenderFns } from "./CardInformation.vue?vue&type=template&id=079f91b1&scoped=true&"
import script from "./CardInformation.vue?vue&type=script&lang=ts&"
export * from "./CardInformation.vue?vue&type=script&lang=ts&"
import style0 from "./CardInformation.vue?vue&type=style&index=0&id=079f91b1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079f91b1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
